export function AbBadgeOverlay({ isVisible }, { zIndex }) {
    return (
        <div>
            <div className={`ab-badge-overlay ${isVisible && 'ab-badge-overlay-visible'}`} style={{ zIndex: (zIndex + 20) }}></div>
        </div>
    )
}